import React from "react";

import { Stack } from "../Stack";

import type { DirectionStackProps } from "../Stack";

/**
 * HStack / VStack – Layout components for horizontally or vertically spacing all children equidistant.
 * Frequently used with spacing={spacing.md}.
 *
 * example: https://smartrent-ui.com/components/layout/stack
 */
export function VStack({ reverse, ...props }: DirectionStackProps) {
  return <Stack {...props} direction={reverse ? "column-reverse" : "column"} />;
}
